import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import MovieDetails from './pages/MovieDetails';
import Favorites from './pages/Favorites';
import Contact from './pages/Contact';
import { ThemeProvider } from './utils/ThemeContext';
import { FavoritesProvider } from './utils/FavoritesContext';
import './App.css';

// Wrapper component to handle routing logic passed to Header
const AppContent = () => {
  const navigate = useNavigate();

  const handleSearch = (query) => {
    navigate(`/?s=${encodeURIComponent(query)}`);
  };

  return (
    <>
      <Header onSearch={handleSearch} />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/movie/:imdbID" element={<MovieDetails />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={
            <div className="container" style={{ textAlign: 'center', marginTop: '4rem' }}>
              <h1>404 - Page Not Found</h1>
            </div>
          } />
        </Routes>
      </main>
    </>
  );
};

function App() {
  return (
    <Router>
      <ThemeProvider>
        <FavoritesProvider>
          <div className="app">
            <AppContent />
          </div>
        </FavoritesProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
